import { Schema } from 'effect';
import { VehicleIdSchema } from './vehicle';

export const SubmitVehicleDiscrepancyReportRequestSchema = Schema.transform(
  Schema.Struct({
    vehicle_id: VehicleIdSchema,
    description: Schema.NullOr(Schema.String)
  }),
  Schema.Struct({
    vehicleId: VehicleIdSchema,
    description: Schema.NullOr(Schema.String)
  }),
  {
    strict: true,
    decode: (api) => ({
      vehicleId: api.vehicle_id,
      description: api.description
    }),
    encode: (client) => ({
      vehicle_id: client.vehicleId,
      description: client.description
    })
  }
);
export type SubmitVehicleDiscrepancyReportRequest = Schema.Schema.Type<
  typeof SubmitVehicleDiscrepancyReportRequestSchema
>;
